import { QUICK_SHOP_VIEW_GRID, QUICK_SHOP_VIEW_LIST } from 'components/QuickShopPage/constants';

type QuickShopView = typeof QUICK_SHOP_VIEW_GRID | typeof QUICK_SHOP_VIEW_LIST;

interface CookiePreference {
  view?: string;
}

const isValidQuickShopView = (view?: string): view is QuickShopView =>
  view === QUICK_SHOP_VIEW_LIST || view === QUICK_SHOP_VIEW_GRID;

const parseCookiePreference = (cookieValue: string): CookiePreference | undefined => {
  try {
    return JSON.parse(cookieValue) as CookiePreference;
  } catch {
    return undefined;
  }
};

export const getQuickShopResolvedView = ({
  cookiesConsented,
  savedCookieQuickShopViewPreference,
  urlView,
}: {
  cookiesConsented: boolean;
  savedCookieQuickShopViewPreference?: string;
  urlView?: string;
}): QuickShopView => {
  if (isValidQuickShopView(urlView)) {
    return urlView;
  }

  if (cookiesConsented && savedCookieQuickShopViewPreference) {
    const parsedCookiePreference = parseCookiePreference(savedCookieQuickShopViewPreference);

    if (isValidQuickShopView(parsedCookiePreference?.view)) {
      return parsedCookiePreference.view;
    }
  }

  return QUICK_SHOP_VIEW_GRID;
};
